import AddContactDialog from "@/views/settings/mailing/mailingView/addContactDialog/AddContactDialog.vue";
import { MailingTypes } from "@/enums/MailingTypes";
import moment from "moment";
import Loader from "@/components/loader/Loader.vue";
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import { FamilyHubAppStatus } from "@/enums/FamilyHubAppStatus";
import firebase from "firebase";
import {FamilyHubUserStatus} from "@/enums/FamilyHubUserStatus";
import { ResidentStatus } from "@/enums/ResidentStatus";

export default {
  name: "MailingView",
  components: {
    AddContactDialog,
    ConfirmDlg,
    Loader
  },
  data() {
    return {
      headersCustom: [
        {
          text: this.$t('GeneralTranslations.FirstName'),
          value: "name"
        },
        {
          text: this.$t('GeneralTranslations.LastName'),
          value: "surname"
        },
        {
          text: this.$t('GeneralTranslations.Email'),
          value: "email"
        },
        {
          text: "",
          value: "action"
        },
      ],
      headersDefault: [
        {
          text: this.$t('GeneralTranslations.FirstName'),
          value: "name"
        },
        {
          text: this.$t('GeneralTranslations.Email'),
          value: "email"
        },
        {
          text: "",
          value: "action"
        },
      ],
      mailingTypes: MailingTypes,
      subscribed: [],
      unsubscribed: [],
      loader: true
    }
  },
  methods: {
    open() {
      this.$refs.addContactDialog.open();
    },
    async deleteMailingList(){
      if(this.mailing.type === this.mailingTypes.Custom){

       let message = `Are you sure you want to delete <b>${this.mailing.name}</b> mailing list?`;
       const emailTemplates = await this.$store.dispatch("getEmailTemplateTypesByMailingList", this.mailing)
        
       if(emailTemplates.length){
        const warnMessage = `This mailing list is being used by certain email templates. These templates will be disabled if you delete this mailing list.`;
        message = `${message} <br><br> ${warnMessage}`
       }


        (this.$refs.confirmationModal as any)
        .open(null, message, false)
        .then(response => {
          if (response && response.agree) {
             this.$store.dispatch("deleteFacilityMailingList", this.mailing).then(()=>{
                this.$router.push("/settings?tab=mailingList")
             })
          }
        });
      }
    },
    checkMailingType() {
      switch (this.mailing.type) {
        case this.mailingTypes.Staff:
          this.subscribed = this.staff;
          break;
        case this.mailingTypes.Residents:
          this.subscribed = this.residents;
          break;
        case this.mailingTypes.Family:
          this.familyMembers
            .filter(member => member.appStatus !== FamilyHubAppStatus.ReadOnly && member.status !== FamilyHubUserStatus.Archived)
            .forEach(item => {
              if(!item.isUnsubscribedFromEmails){
                this.subscribed.push(item);
              } else {
                this.unsubscribed.push(item);
              }
            });
          break;
        case this.mailingTypes.PendingFamilyMembers:
          this.subscribed = this.familyMembers.filter(x=>x.appStatus === FamilyHubAppStatus.Pending);
          break;
        case this.mailingTypes.Custom:
          this.subscribed = this.mailing.to;
          break;
        case this.mailingTypes.ArchivedFamilyMembers:
          this.subscribed = this.archivedFamilyMembers;
          break;
        case this.mailingTypes.FamilyWithFEPOA:
          this.subscribed = this.EPOAFamilyMembers;
          break;
        case this.mailingTypes.FamilyCanInviteOtherFamily:
          this.subscribed = this.familyCanInviteOtherFamily;
          break;
        case this.mailingTypes.FamilyMembersNotUsingTheApp:
          this.subscribed = this.familyMembersNotUsingTheApp;
          break;
        case this.mailingTypes.FamilyMembersWithTheAppActivated:
          this.subscribed = this.familyMembersWithTheAppActivated;
          break;
        case this.mailingTypes.FamilyMembersPerWing:
          this.subscribed = this.familyMembersWithWings.filter((family) => family.wingId === this.mailing?.wingId)
          break;
        case this.mailingTypes.FamilyMembersPerLevelOfCare:
          this.subscribed = this.familyMembersPerLevelOfCare.filter((family) => family.careLevelIds.includes(this.mailing?.careLevelId))
          break;
      }
    },
    groupByHour(sent) {
      const result = sent.reduce(function(totals, sent) {
        const dayOfWeek = moment(sent.date.seconds * 1000)
            .startOf("day")
            .format("LL");
        !totals[dayOfWeek]
          ? (totals[dayOfWeek] = 1)
          : (totals[dayOfWeek] = totals[dayOfWeek] + 1);
        return totals;
      }, {})
      return result;
    },
    deleteContact(item) {
      (this.$refs.confirmationModal as any)
        .open(null, this.$t("MailingView.DeleteContact").replace('[name]', `${item.surname} ${item.name}`), false)
        .then(response => {
          if (response && response.agree) {
            firebase
              .firestore()
              .collection('mailingLists')
              .doc(this.$route.params.id)
              .update({
                to: firebase.firestore.FieldValue.arrayRemove(item)
              })
              .then(async () => {
                await this.$store.dispatch("getFacilityMailingById", this.$route.params.id);
                this.checkMailingType();
              })
              .catch((data) => {
                this.$toast.open({
                  message: data.message,
                  type: 'error',
                });
              });
          }
        });
    }
  },
  computed: {
    mailing() {
      return this.$store.state.facilityModule.facilityMailingCurrent;
    },
    mailingInfo() {
      return this.$store.state.facilityModule.facilityMailingSendedCurrent;
    },
    staff() {
      return this.$store.state.facilityModule.selectedFacilityUsers;
    },
    residents() {
      return this.$store.state.residentModule.residentsShortData;
    },
    familyMembers() {
      return this.$store.state.residentModule.familyMembers;
    },
    isMailingCustom() {
      return this.mailing.type === this.mailingTypes.Custom;
    },
    facility() {
      return this.$store.state.authModule.currentFacility;
    },
    allFamilyMembers() {
      return this.$store.state.residentModule.familyMembers;
    },
    archivedFamilyMembers() {
      return this.allFamilyMembers.filter(x => (x.status === FamilyHubUserStatus.Archived || (x.residents || []).some(y => y.status === ResidentStatus.Departed)))
    },
    pendingFamilyMembers() {
      return this.allFamilyMembers.filter(x=>x.appStatus === FamilyHubAppStatus.Pending);
    },
    EPOAFamilyMembers() {
      return this.allFamilyMembers.filter(family => family?.financialEPOA?.some(epoa => epoa.status === true) == true)
    },
    familyCanInviteOtherFamily() {
      return this.allFamilyMembers.filter(family => family?.isCanInvite == true)
    },
    familyMembersNotUsingTheApp() {
      return this.allFamilyMembers.filter(family => !family?.invitedToFamilyApp)
    },
    familyMembersWithTheAppActivated() {
      return this.allFamilyMembers.filter(family => family.appStatus === FamilyHubAppStatus.Activated)
    },
    familyMembersWithWings(){
     return this.residents.filter((resident: any) =>  resident.status === ResidentStatus.ActiveResident && resident?.familyHubUsersIds?.length > 0 && this.wingsIds.includes(resident.wingId))
        .map((resident: any) => 
            this.allFamilyMembers.filter((familyMember: any) => resident?.familyHubUsersIds?.includes(familyMember.id))
        .map((user: any) => ({
            ...user, 
            wingId: resident.wingId,
            wingName: resident.wingName })
        ))
        .flat()
        .reduce((unique: any[], user: any) => { if (!unique.some((u) => u.id === user.id)) { unique.push(user) } return unique }, []);
    },
    familyMembersPerLevelOfCare(){
      return this.residents.filter((resident: any) =>  resident.status === ResidentStatus.ActiveResident && resident?.familyHubUsersIds?.length > 0 && this.careLevelsWingsIds?.includes(resident.wingId))
        .map((resident: any) => 
            this.allFamilyMembers.filter((familyMember: any) => resident?.familyHubUsersIds?.includes(familyMember.id))
        .map((user: any) => ({
            ...user, 
            careLevelIds: this.careLevels.filter((careLevel: any) => careLevel.wingsIds.includes(resident.wingId)).map((careLevel: any) => careLevel.id)})
        ))
        .flat()
        .reduce((unique: any[], user: any) => { if (!unique.some((u) => u.id === user.id)) { unique.push(user) } return unique }, []);
    },
    wings() {
      return this.$store.state.eventLocationModule.eventWings;
    },
    careLevels() {
      return this.$store.state.careLevelsModule.careLevels
    },
    careLevelsIds() {
      return this.$store.state.careLevelsModule.careLevels.map((x) => x.id);
    },
    careLevelsWingsIds(){
      return [...new Set(this.careLevels.flatMap(level => level.wingsIds))];
    },
    wingsIds() {
      return this.wings.map((wing: any) => wing.id);
    }
  },
  async mounted() {
    await this.$store.dispatch("getFacilityMailingById", this.$route.params.id);
    await this.$store.dispatch("getFacilityMailingSendedById", {
      id: this.$route.params.id,
      facilityId: this.facility
    });
    if(!this.familyMembers?.length){
      this.$store.dispatch("getFamilyMembers")
    }

    if(!this.careLevels?.length){
      this.$store.dispatch("getCareLevels")
    }

    if(!this.wings?.length){
      this.$store.dispatch("getEventWings")
    }
    this.checkMailingType();
    this.loader = false;
  }
}